<template>

<v-row>

  <v-col class="mb-4">
    <v-switch inset v-model="properties.public" 
    color="primary"
    @click="layerToggled(phytosociologicalLayer)" 
    density="compact"
    label=" Pubblica" 
    class="text-left mr-2"
    >
    <template #details>
        <span v-if="properties.public">
          <v-icon 
          size="small"
          color="warning"
          class="mr-2 mb-1"
          >
          mdi-alert
        </v-icon>
        Le informazioni inserite saranno disponibili a tutti i colleghi.
      </span>
        <span v-else>
          <v-icon 
          size="small"
          color="primary"
          class="mr-2 mb-1 text-left"
          >
          mdi-information-outline
        </v-icon>
        Le informazioni saranno visibili solo a te (ma saranno sincronizzate sul server). 
      </span>
    </template>
  </v-switch>
</v-col>
<v-col class="mb-4 text-right">
  <v-slider
    label="Priorità"
    v-model="properties.priority"
    :max="10"
    :min="1"
    :step="1"
    thumb-label
    :color="sliderColor"
  >
  <template #append>
    {{ properties.priority }}
  </template>
  </v-slider>
  </v-col>
</v-row>


<v-row>

  <v-col class="">

    
    <p class="text-headline-small mt-3">Nome</p>
    <v-text-field  required outlined v-model="properties.codice"
    @update:model-value="setLabel"
    >
  </v-text-field>
</v-col>
</v-row>

    <v-row>
      <v-col class="">
        <p class="text-headline-small mt-3">Descrizione</p>
        <v-textarea label="" v-model="properties.note"></v-textarea>
      </v-col>
    </v-row>


    <v-row>
      <v-col class="">
    <p class="text-headline-small mt-3">Icona</p>

        <v-btn 
          variant="flat"
        :color="properties.icon === null ? 'primary' : 'grey'"
        class="ma-2 pa-6"
        size=""
        @click="properties.icon = null"
        >
          senza icona 
        </v-btn><br >
        <v-btn 
          v-for ="icon in allowedIcons"
          variant="flat"
        :color="properties.icon === icon.code ? 'primary' : 'grey'"
        class="ma-2"
        size=""
        @click="properties.icon = icon.code"
        >
          <v-icon class="ma-5" size="x-large">mdi-{{icon.code}}</v-icon>
        </v-btn>



      </v-col>
    </v-row>

    <!-- <v-row>
      <v-col class="">
    <p class="text-headline-small mt-3">Color</p>
    <v-color-picker v-model="properties.color" landscape mode="rgb" hide-inputs hide-mode-switch class="w-100"></v-color-picker>

      </v-col>
    </v-row> -->
    
    <v-row>
      <v-col class="mb-5">
      </v-col>
    </v-row>
    
</template>

<script setup>


import SegnalazioneCommon from "@/reports/components/SegnalazioneCommon";
import { computed, onMounted } from 'vue'
import { useToastsStore } from "@/store/toasts";
import { useCopyToClipboard } from "@/service/copyToClipboard";
const properties = defineModel()
const {copy2clipboard}  = useCopyToClipboard();

// eslint-disable-next-line no-unused-vars
const props = defineProps({
  "isNew": {
    type: Boolean,
    default: false
  }
})

const validatedIcon = computed(() => {
  const fullString = `mdi-${properties.value.icon}`;
  // You could add a simple regex check here to ensure no illegal characters
  return "mdi-"+properties.value.icon ? fullString : 'mdi-help-circle-outline';
});


const setLabel = () => {
  if (properties.value.codice) {
    properties.value.label = `Nota: ${properties.value.codice}`
  }
  else {
    properties.value.label = "Nota"
  }
}

const allowedIcons = [
  { code:'star', name: 'Star' },
  { code:'heart', name: 'Heart' },
  { code:'flag', name: 'Flag' },
  { code:'eye', name: 'Eye' },
  { code:'alert', name: 'Alert' },
  { code:'information-outline', name: 'Information Outline' },
  { code:'check', name: 'Check' },
  { code:'close', name: 'Close' },
  { code:'map-marker', name: 'Map Marker' },
  { code: 'magnify', name: 'Magnify' },
]

const sliderColor = computed(() => {
  if (properties.value.priority <= 3) {
    return 'grey'
  }
  else if (properties.value.priority <= 8) {
    return 'primary'
  }
  else {
    return 'green'
  }
})

onMounted(() => {
  setLabel()
  if (!properties.value.priority){
  properties.value.priority = 5
  }


  if (!properties.value.icon){
  properties.value.icon = "star"
  }
})

</script>
